// Servicio para interactuar con Electron APIs
class ElectronService {
  constructor() {
    this.isElectron = window.electron !== undefined;
  }

  // Verificar si estamos en Electron
  isElectronApp() {
    return this.isElectron;
  }

  // IPC - Comunicación con el proceso principal
  async invoke(channel, ...args) {
    if (!this.isElectron) {
      console.warn('Electron no está disponible');
      return null;
    }

    try {
      return await window.electron.ipcRenderer.invoke(channel, ...args);
    } catch (error) {
      console.error(`Error en IPC invoke ${channel}:`, error);
      throw error;
    }
  }

  // Enviar mensaje al proceso principal
  send(channel, ...args) {
    if (!this.isElectron) {
      console.warn('Electron no está disponible');
      return;
    }

    window.electron.ipcRenderer.send(channel, ...args);
  }

  // Escuchar eventos del proceso principal
  on(channel, callback) {
    if (!this.isElectron) {
      console.warn('Electron no está disponible');
      return () => {};
    }

    return window.electron.ipcRenderer.on(channel, callback);
  }

  // === SERVICIOS ESPECÍFICOS ===

  // Impresión
  async printDocument(printerName, htmlContent, options = {}) {
    return await this.invoke('print-document', {
      printerName,
      htmlContent,
      silent: true,
      ...options
    });
  }

  // Obtener impresoras disponibles
  async getPrinters() {
    return await this.invoke('get-all-printers');
  }

  // Probar estado de impresora
  async testPrinter(printerName) {
    return await this.invoke('get-printer-status', printerName);
  }

  // Guardar archivo
  async saveFile(fileName, content) {
    return await this.invoke('save-file', { fileName, content });
  }

  // Test de IPC
  async testIPC() {
    return await this.invoke('test-ipc', {
      timestamp: new Date().toISOString(),
      message: 'Test desde React'
    });
  }
}

// Crear instancia singleton
const electronService = new ElectronService();

export default electronService;